import {Component, inject, Input, OnInit} from '@angular/core';
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {FaIconService} from "../../../services/fa-icon.service";

@Component({
  selector: 'app-font-awesome-icon',
  templateUrl: './font-awesome-icon.component.html',
  styleUrl: './font-awesome-icon.component.scss'
})
export class FontAwesomeIconComponent implements OnInit {

  @Input({ required: true }) iconName: string;

  private faService: FaIconService = inject(FaIconService);

  icon: IconDefinition

  ngOnInit() {

    this.icon = this.faService.faIcons.find(i => i.name === this.iconName)?.definition

  }

}
